// components/filter/filter-component.jsx
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { RiFilterOffFill } from "react-icons/ri";

import { setFilterNull } from "../../redux/filter/filter.actions";
import {
  getPriorityOptions,
  getPriorityFilterScope,
} from "../../utils/priorities";

import PriorityFilter from "./priority-filter/priority-filter.component";
import TimeFilter from "./time-filter/time-filter.component";
import PersonFilter from "./person-filter/person-filter.component";

import "./filter-styles.scss";

const Filter = ({ station }) => {
  const filter = useSelector((state) => state.filter);
  const currentUser = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();

  const priorities = getPriorityOptions(
    station
      ? station.priorities
      : currentUser?.quickTaskPriorities,
  );

  const scope = getPriorityFilterScope(
    station
      ? station.spaceId || station.fromSpaceId
      : `${currentUser?.uid}-Inbox`,
    station ? station.stationId || station.id : null,
  );

  return (
    <div className="filter">
      <div
        className="filter__text"
        onClick={() => dispatch(setFilterNull())}
      >
        <RiFilterOffFill size="1.4em" />
      </div>

      <div className="filter__types">
        <div className="filter__group-top">
          <PersonFilter />

          <div className="filter__time">
            <TimeFilter time={filter.time} />
          </div>
        </div>

        <div className="filter__priority-fire">
          {priorities.map((priority) => (
            <PriorityFilter
              key={priority.id || priority.value}
              priority={priority}
              scope={scope}
              selected={
                filter.priorityScope === scope &&
                (filter.status || []).includes(priority.value)
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Filter;
